export const NO_FACILITY_NEARBY = "No facility nearby";

export const DEFAULT_MAP_COORDINATES = {
  latitude: 39.508921,
  longitude: -101.66892,
};
